import React from 'react';
import { useNavigate } from 'react-router-dom';
import { MEDIA_BASE_URL } from '../services/api';
import WishlistButton from '../components/WishlistButton';
import './ProductCard.css';

function ProductCard({ product, onClick }) {
	const navigate = useNavigate();
	
	const getFirstImage = () => {
		if (product.main_images && product.main_images.length > 0) {
			const firstImage = product.main_images.find(url => 
				!url.toLowerCase().endsWith('.mp4')
			);
			if (firstImage) {
				if (firstImage.startsWith('/media')) {
					return `https://api.weartoday.kr${firstImage}`;
				}
				return firstImage.startsWith('http') 
					? firstImage 
					: `${MEDIA_BASE_URL}${firstImage}`;
			}
		}
		
		if (product.image && !product.image.toLowerCase().endsWith('.mp4')) {
			if (product.image.startsWith('/media')) {
				return `https://api.weartoday.kr${product.image}`;
			}
			return product.image.startsWith('http')
				? product.image
				: `${MEDIA_BASE_URL}${product.image}`;
		}
		
		return null;
	};
	
	const handleClick = (e) => {
		if (e.target.closest('.wishlist-button')) {
			e.stopPropagation();
			return;
		}
		
		// ✅ 스크롤 위치 저장 콜백 호출
		if (onClick) {
			onClick();
		}
		
		navigate(`/product/${product.id}`);
	};
	
	const displayPrice = product.display_price || product.price || 0;
	const basePrice = product.base_price || 0;
	const discountRate = product.discount_rate || 0;
	
	const imageUrl = getFirstImage();
	
	return (
		<div className="product-card" onClick={handleClick}>
			<div className="product-image">
				<img 
					src={imageUrl || 'https://via.placeholder.com/250?text=No+Image'}
					alt={product.name}
					loading="lazy"
					onError={(e) => {
						e.target.onerror = null;
						e.target.src = 'https://via.placeholder.com/250?text=No+Image';
					}}
				/>
				<div className="wishlist-btn-wrapper">
					<WishlistButton productId={product.id} />
				</div>
			</div>
			<div className="product-info">
				<h3>{product.name}</h3>
				<div className="price-wrapper">
					<span className="price">₩{Number(displayPrice).toLocaleString()}</span>
					{discountRate > 0 && (
						<>
							<span className="base-price">₩{Number(basePrice).toLocaleString()}</span>
							<span className="discount-rate">{discountRate}% OFF</span>
						</>
					)}
				</div>
			</div>
		</div>
	);
}

export default ProductCard;